<div class="page-background-blue">
  <ion-grid class="list-checks-wrapper">
    <ion-row>
      <h1 class="bottom-sheet-title"> {{ 'list-of-checks.previous_ten' | translate }} </h1>
    </ion-row>
    @if (data?.previousChecks?.length) {
      <ion-row class="page-padding checks-heading">
        <ion-col class="ion-no-padding" size="2.5">
          <h1 class="title txt-clr-light-blue ion-text-left">
            {{'list-of-checks.Check date' | translate}}
          </h1>
        </ion-col>
        <ion-col class="ion-no-padding" size="2.5">
          <h1 class="title ion-text-center txt-clr-light-blue">{{'list-of-checks.Lottery' | translate}}
          </h1>
        </ion-col>
        <ion-col class="ion-no-padding" size="2.5">
          <h1 class="title ion-text-center txt-clr-light-blue">{{'list-of-checks.Points' | translate}}
          </h1>
        </ion-col>
        <ion-col class="ion-no-padding" size="2.5">
          <h1 class="title ion-text-center txt-clr-light-blue">{{'list-of-checks.Prizes' | translate}}
          </h1>
        </ion-col>
        <ion-col class="ion-no-padding ion-text-right" size="2"></ion-col>
      </ion-row>
      @for (check of data?.previousChecks; track check) {
        <ion-row class="page-padding item-rows bg-white">
          <ion-col class="ion-no-padding" size="2.5">
            <h1 class="title txt-clr-light-blue ion-text-left check-date">
              {{ check.check_winning_date?.toDate() | date: "d"}} {{ 'dynamic_value.'+(check.check_winning_date?.toDate() | date: "MMM") | translate }}
            </h1>
          </ion-col>
          <ion-col class="ion-no-padding" size="2.5">
            @if (check.cash_won || check.credit_won) {
              <mat-icon class="smiley-emoji checked-lc-10">done</mat-icon>
            }
            @if (!(check.cash_won || check.credit_won)) {
              <mat-icon class="smiley-emoji txt-clr-light-blue">close
              </mat-icon>
            }
          </ion-col>
          <ion-col class="ion-no-padding" size="2.5">
            @if (check.points_won) {
              <mat-icon class="smiley-emoji ion-padding-end checked-lc-10">done</mat-icon>
            }
            @if (!check.points_won) {
              <mat-icon class="smiley-emoji ion-padding-end txt-clr-light-blue">close</mat-icon>
            }
          </ion-col>
          <ion-col class="ion-no-padding" size="2.5">
            @if (check.gift_won) {
              <mat-icon class="smiley-emoji checked-lc-10">done</mat-icon>
            }
            @if (!check.gift_won) {
              <mat-icon class="smiley-emoji txt-clr-light-blue">close</mat-icon>
            }
          </ion-col>
          <ion-col class="ion-no-padding ion-text-right" size="2">
            <mat-icon class="material-icons-outlined  previous-right-arrow"
            (click)="openPrizePage(check.encr_claim_event_id)">arrow_forward_ios</mat-icon>
          </ion-col>
        </ion-row>
      }
    }
    @if (!data?.previousChecks?.length) {
      <div class="no-ticket-wrapper">
        <span class="magnifying-emoji">🔎</span>
        <p>
          {{'list-of-checks.days' | translate}} <br />{{'list-of-checks.error' | translate}}
          <span class="link-text-blue" (click)="helpSupportWebview()">{{'list-of-checks.support' | translate}}</span>
        </p>
      </div>
    }
  </ion-grid>
  <p class="back-arrow" (click)="backToSyndicate()"><span class="arrow">←</span> Close </p>
</div>